// What the brand pages say about whether moderation applies to the brand
// now, from GET /:org/moderation/status. context is 'rules' (the phrase
// rules page) or 'queue' (the moderation queue).

const BANNER_VIEWS = {
  platform_off: {
    variant: 'warning',
    rules: 'Content moderation is off for every brand. Posts go live without moderation checks; these rules apply once Wager turns it on.',
    queue: 'Content moderation is off for every brand. Posts go live without moderation checks, so nothing new comes to this queue.',
  },
  org_off: {
    variant: 'warning',
    rules: 'Moderation is off for this brand. Posts go live without moderation checks; these rules apply once Wager turns it on for this brand.',
    queue: 'Moderation is off for this brand. Posts go live without moderation checks. Reviews already here can still be decided.',
  },
  shadow: {
    variant: 'info',
    rules: 'Moderation is in observe-only mode: posts are checked and the results recorded, but no rule holds or refuses a post.',
    queue: 'Moderation is in observe-only mode: posts are checked and the results recorded, but none is held here.',
  },
  human_review: {
    variant: 'info',
    rules: 'Moderation is on for this brand. A blocked phrase stops a save; a flagged phrase sends the post to the moderation queue.',
    queue: 'Moderation is on for this brand. Flagged posts wait here until a brand admin decides.',
  },
  auto_reject: {
    variant: 'info',
    rules: 'Moderation is on for this brand. A blocked phrase stops a save; a flagged phrase rejects the post automatically, and a brand admin can overturn it.',
    queue: 'Moderation is on for this brand and flagged posts are rejected automatically. A brand admin can overturn them under Auto-rejected.',
  },
}

function bannerState(status) {
  if (status.platform_mode === 'off') return 'platform_off'
  if (!status.org_enabled) return 'org_off'
  if (status.platform_mode === 'shadow') return 'shadow'
  return status.flagged_content === 'auto_reject' ? 'auto_reject' : 'human_review'
}

// moderationStateBannerView is { variant, text } for the banner, or null
// without a status (still loading, or the read failed). The platform switch
// is checked first, then the brand's, then shadow mode.
export function moderationStateBannerView(status, context) {
  if (!status) return null
  const view = BANNER_VIEWS[bannerState(status)]
  return { variant: view.variant, text: context === 'queue' ? view.queue : view.rules }
}
